module.exports = __webpack_public_path__ + "static/media/palpatine.ab9b74ab.jpg";